// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__UXbvb","label":"SetPasswdForm_label__3PWdR"};